import { useMutation, useQueryClient } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

import { luxPlusPurchaseRestrictionsQueryKeys } from './useGetLuxPlusPurchaseRestrictions';

export function useUpdateLuxPlusPurchaseRestrictions() {
  const queryClient = useQueryClient();

  return useMutation({
    // Wrapped instead of passed as a bare reference — as a static method, it relies on
    // `this` being the OffersService class, which a bare reference call loses.
    mutationFn: (payload: Parameters<typeof OffersService.updateLuxPlusPurchaseRestrictions>[0]) =>
      OffersService.updateLuxPlusPurchaseRestrictions(payload),
    // Returned so mutateAsync only resolves once the refetched list has landed — callers
    // reset local edits off the fresh query data and shouldn't do so against stale rows.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: luxPlusPurchaseRestrictionsQueryKeys.all }),
  });
}
